import "@/App.css";
import { VaultProvider, useVault } from "@/context/VaultContext";
import { Toaster } from "@/components/ui/sonner";
import Gate from "@/components/LockScreen";
import MainLayout from "@/components/MainLayout";
import { StarLogo } from "@/components/StarLogo";

function Root() {
  const { ready, unlocked, theme } = useVault();
  return (
    <>
      {!ready ? <div className="min-h-screen bg-background flex items-center justify-center" data-testid="splash"><StarLogo className="h-16 w-16 sv-rise" /></div> : unlocked ? <MainLayout /> : <Gate />}
      <Toaster theme={theme} position="top-center" offset={68} />
    </>
  );
}

export default function App() {
  return (
    <VaultProvider>
      <Root />
    </VaultProvider>
  );
}
